import { useCreateAptStore, usePackageBookingStore } from "@elixir/stores";
import { PACKAGE_POPUP_TYPE } from "@elixir/types";
import React from "react";
import { NewAptSelectExistingPackageUi, SelectSessionsToUseUi } from "ui";
import useGetQueueConfig from "../../../apis/tryst/get-queue-config";
import useGetPatientOverview from "../../../apis/tryst/use-get-patient-overview";
import useQueueStore from "../../../stores/queue-store";
import { track } from "../../../utils/tracking";

const NewAptSelectExistingPackage = () => {
  const selectedPatient = useQueueStore((state) => state.selectedPatient);
  const selectedInclusionIds = useCreateAptStore(
    (state) => state.selectedInclusionIds
  );
  const selectedDoctor = useCreateAptStore((state) => state.selectedDoctor);
  const setSelectedInclusionIds = useCreateAptStore(
    (state) => state.setSelectedInclusionIds
  );

  const [showSessionsPopup, setShowSessionsPopup] =
    React.useState<boolean>(false);

  const { data: patientOverviewData } = useGetPatientOverview({
    patientId: selectedPatient?.oid || ""
  });

  const { data: queueConfig } = useGetQueueConfig();

  const setPackagePopupType = usePackageBookingStore(
    (state) => state.setPackagePopupType
  );
  const setSelectedPatient = usePackageBookingStore(
    (state) => state.setSelectedPatient
  );
  const setConductingDoctor = usePackageBookingStore(
    (state) => state.setConductingDoctor
  );

  if (!selectedPatient) return null;

  const { package: packageInfo } = patientOverviewData || {};

  const handleSelectInclusion = (inclusionId: number) => {
    const currIndex = selectedInclusionIds.findIndex(
      (val) => val === inclusionId
    );
    if (currIndex === -1) {
      setSelectedInclusionIds([...selectedInclusionIds, inclusionId]);
    } else {
      setSelectedInclusionIds([
        ...selectedInclusionIds.slice(0, currIndex),
        ...selectedInclusionIds.slice(currIndex + 1),
      ]);
    }
  };

  const handleClosePopup = () => {
    setShowSessionsPopup(false);
  };

  const handleStartPackageClick = () => {
    track("apt_form_start_package_click");
    if (!patientOverviewData?.patient) return;
    setSelectedPatient(patientOverviewData.patient);
    setPackagePopupType(PACKAGE_POPUP_TYPE.START_TREATMENT);
    setConductingDoctor(selectedDoctor!);
  };

  const handleSessionPopup = (status: boolean) => {
    if (status) {
      track("apt_form_session_popup_click");
    }
    setShowSessionsPopup(status);
  };

  return (
    <NewAptSelectExistingPackageUi
      selectedInclusionIds={selectedInclusionIds}
      openSessionsPopup={showSessionsPopup}
      setOpenSessionsPopup={handleSessionPopup}
      packageInfo={packageInfo}
      packages={queueConfig?.data?.packages}
      onSelectPackageClick={handleStartPackageClick}
      canUsePackage={packageInfo?.can_use_package}
      PopupContent={
        packageInfo ? (
          <SelectSessionsToUseUi
            selectedInclusionIds={selectedInclusionIds}
            onInclusionSelect={handleSelectInclusion}
            onGoBackClick={handleClosePopup}
            onClose={handleClosePopup}
            packageInfo={packageInfo}
          />
        ) : null
      }
    />
  );
};

export default NewAptSelectExistingPackage;
